import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const certificateList = createAsyncThunk('certificateList', async () => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `certificates`,
            params: {
                type: 'fy'
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const certificateListSlice = createSlice({
    name: 'certificateList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(certificateList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(certificateList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default certificateListSlice.reducer; 